import React from 'react'
import { Card } from "react-bootstrap";
import styles from "./VCard.module.scss";


export interface VCardInterface {
  risk?: string;
  title?: string;
  details?: string;
  image?: string;
  data?: CardData[] | null;
  customStyles?: React.CSSProperties | undefined;
}

export interface CardData {
  title: string;
  value: string;
  change: string;
  isRiskUp?: boolean;
}

export default function VCard({ risk, title, details, image , data, customStyles }: VCardInterface) {
  return (
    <Card className={styles.card} style={customStyles}>
      <Card.Body>
        {image && (
          <div className={styles.img} style={{ backgroundImage: `url(${image})` }}></div>
        )}

        {risk && <span className={styles.risk}> {risk}</span>}

        {title && <Card.Title>{title}</Card.Title>}

        {details && <Card.Text className="text-gray-400">{details}</Card.Text>}

        <div className="d-flex mb-4">
          {data?.map((col , i) => (
            <div key={i} className={styles.col}>
              <small className="text-gray-500 text-uppercase text-7s">
                {col.title}
              </small>
              <h5 className="mv-0 fw-300 d-flex align-items-end">
                <span className='mr-1'> {col.value} </span>
                <small className={ col.isRiskUp ? "text-info text-7s" : "text-error text-7s" } >
                  <i className={ col.isRiskUp ? "icon-arrow-down" : "icon-arrow-up"}></i>
                  {col.change}
                </small>
              </h5>
            </div>
          ))}
        </div>

        <button className="fw btn btn-outline-secondary">View Risk</button>
      </Card.Body>
    </Card>
  );
}
